module.exports = __webpack_public_path__ + "img/king.07c655cb.png";